import { HStack } from '@rbilabs/universal-components';

import { MarketingBasicTile } from 'components/marketing-basic-tile';
import { getDesignToken, primitive } from 'styles/constants';
export const Section = HStack.withConfig({
  width: 'full',
  maxWidth: getDesignToken('layout-section-max-width'),
  justifyContent: 'center',
  flexGrow: 1,
  flexShrink: 1,
  flexBasis: 'auto',
  marginX: { base: 'auto', md: '$6' },
  marginTop: {
    base: '$4',
    md: 0,
  },
  marginBottom: '$4',
  paddingX: {
    base: '$3',
    md: 0,
  },
});

export const LeftContainer = HStack.withConfig({
  flex: { md: 1 },
  paddingRight: { md: '$2' },
});

export const RightContainer = HStack.withConfig({
  flex: { md: 1 },
  paddingLeft: {
    md: '$2',
  },
});

export const QuadTileContainer = HStack.withConfig({
  maxWidth: { md: '800px' },
  justifyContent: 'center',
});

export const StyledBasicTile = MarketingBasicTile.withConfig<{ newUI?: boolean }>(p => ({
  background: p.newUI ? null : primitive.$mayoEggWhite,
  flexDirection: 'row',
  padding: '$4',
  margin: '$4',
  borderRadius: 'md',
  shadow: p.newUI ? '0px' : '2px',
  borderWidth: p.newUI ? '1' : null,
  borderColor: p.newUI ? primitive.$greyFive : null,
  _basicTileTitle: {
    color: getDesignToken('alert-info-background'),
    fontSize: 'sm',
    lineHeight: '2xs',
    textAlign: 'left',
  },
  _typographyBlock: {
    color: primitive.$bbqBrown,
    fontFamily: 'heading',
    fontSize: 'sm',
    lineHeight: '2xs',
  },
  _basicTileImage: {
    height: 'full',
    marginTop: 'auto',
    marginBottom: 'auto',
    marginLeft: '$0',
    marginRight: '$1',
    maxHeight: '50px',
    maxWidth: '50px',
  },
}));
